import React, { Suspense } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from "react-router-dom";

import { isAuthenticated, isGuest } from "./auth";
import ErrorBoundary from "./helpers/ErrorBoundary";

const Home = React.lazy(() => import("./containers/Home"));
const SearchContainer = React.lazy(() =>
  import("./containers/SearchContainer")
);
const CategoryContainer = React.lazy(() =>
  import("./containers/CategoryContainer")
);
const ProductDetailsContainer = React.lazy(() =>
  import("./containers/ProductDetailsContainer")
);
const MyAccountContainer = React.lazy(() =>
  import("./containers/MyAccountContainer")
);
const PageNotFoundContainer = React.lazy(() =>
  import("./containers/PageNotFoundContainer")
);
const OrdersContainer = React.lazy(() =>
  import("./containers/OrdersContainer")
);
const WishlistContainer = React.lazy(() =>
  import("./containers/WishlistContainer")
);
const OrdersSummeryContainer = React.lazy(() =>
  import("./containers/OrdersSummeryContainer")
);
const CheckoutContainer = React.lazy(() =>
  import("./containers/CheckoutContainer")
);
const BrandProductsContainer = React.lazy(() =>
  import("./containers/BrandProductsContainer")
);
const OrderPlacedContainer = React.lazy(() =>
  import("./containers/OrderPlacedContainer")
);
const FaqContainer = React.lazy(() => import("./containers/FaqContainer"));
const PrivacyPolicyContainer = React.lazy(() =>
  import("./containers/PrivacyPolicyContainer")
);
const ReturnPolicyContainer = React.lazy(() =>
  import("./containers/ReturnPolicyContainer")
);
const TermConditionsContainer = React.lazy(() =>
  import("./containers/TermConditionsContainer")
);
const CancellationPolicyContainer = React.lazy(() =>
  import("./containers/CancellationPolicyContainer")
);
const CompanyContainer = React.lazy(() =>
  import("./containers/CompanyContainer")
);
const OrderReviewContainer = React.lazy(() =>
  import("./containers/OrderReviewContainer")
);
const ReturnContainer = React.lazy(() =>
  import("./containers/ReturnContainer")
);
const ReturnItemsContainer = React.lazy(() =>
  import("./containers/ReturnItemsContainer")
);
const OfferListContainer = React.lazy(() =>
  import("./containers/OfferListContainer")
);
const CampaignOfferContainer = React.lazy(() =>
  import("./containers/CampaignOfferContainer")
);
const SuperSaverContainer = React.lazy(() =>
  import("./containers/SuperSaverContainer")
);
const AddressContainer = React.lazy(() =>
  import("./containers/AddressContainer")
);
const AddAddressContainer = React.lazy(() =>
  import("./containers/AddAddressContainer")
);
const EditAddressContainer = React.lazy(() =>
  import("./containers/EditAddressContainer")
);
const ContactUsContainer = React.lazy(() =>
  import("./containers/ContactUsContainer")
);

const Login = React.lazy(() => import("./containers/Login"));
const Logout = React.lazy(() => import("./containers/Logout"));
const ForgotPassword = React.lazy(() => import("./containers/ForgotPassword"));
const Register = React.lazy(() => import("./containers/Register"));
const VerifyOTP = React.lazy(() => import("./containers/VerifyOTP"));
const ResetPasswordVerifyOTP = React.lazy(() =>
  import("./containers/ResetPasswordVerifyOTP")
);
const SiteLayout = React.lazy(() => import("./layouts/SiteLayout"));
const CheckoutLayout = React.lazy(() => import("./layouts/CheckoutLayout"));
const PlainLayout = React.lazy(() => import("./layouts/PlainLayout"));



const routeList = [ 
  {
    path: "/",
    element: <Home/>,
    layout: SiteLayout,
    exact: true,
    private: false,
  },
  {
    path: "/search",
    element: <SearchContainer/>,
    layout: SiteLayout,
    exact: true,
    private: false,
  },
  {
    path: "/category/:can_name",
    element: <CategoryContainer/>,
    layout: SiteLayout,
    exact: true,
    private: false,
  },
  
  {
    path: "/product/:id",
    element: <ProductDetailsContainer/>,
    layout: SiteLayout,
    exact: true,
    private: false,
  },
  {
    path: "/product/:id/:can_name",
    element: <ProductDetailsContainer/>,
    layout: SiteLayout,
    exact: true,
    private: false,
  },
  {
    path: "/login",
    element: <Login/>,
    layout: PlainLayout,
    private: false,
  },
  {
    path: "/register",
    element: <Register/>,
    layout: PlainLayout,
    private: false,
  },
  {
    path: "/logout",
    element: <Logout/>,
    layout: PlainLayout,
    private: false,
  },
  {
    path: "/otp-verification/:token",
    element: <VerifyOTP/>,
    layout: PlainLayout,
    private: false,
  },
  {
    path: "/checkout",
    element: <CheckoutContainer/>,
    layout: CheckoutLayout,
    private: false,
  },
  {
    path: "/brand/:id",
    element: <BrandProductsContainer/>,
    layout: SiteLayout,
    private: false,
  },
  {
    path: "/order-placed",
    element: <OrderPlacedContainer/>,
    layout: SiteLayout,
    private: false,
  },

  {
    path: "/profile",
    element: <MyAccountContainer/>,
    layout: SiteLayout,
    private: true,
  },
  {
    path: "/orders",
    element: <OrdersContainer/>,
    layout: SiteLayout,
    private: true,
  },
  {
    path: "/order-summery/:id",
    element: <OrdersSummeryContainer/>,
    layout: SiteLayout,
    private: true,
  },
  {
    path: "/reviews/:id",
    element: <OrderReviewContainer/>,
    layout: SiteLayout,
    private: true,
  },
  {
    path: "/wishlists",
    element: <WishlistContainer/>,
    layout: SiteLayout,
    private: true,
  },
  {
    path: "/returns",
    element: <ReturnContainer/>,
    layout: SiteLayout,
    private: true,
  },
  {
    path: "/return-items/:id",
    element: <ReturnItemsContainer/>,
    layout: SiteLayout,
    private: true,
  },
  {
    path: "/faq",
    element: <FaqContainer/>,
    layout: SiteLayout,
    private: false,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicyContainer/>,
    layout: SiteLayout,
    private: false,
  },
  {
    path: "/return-policy",
    element: <ReturnPolicyContainer/>,
    layout: SiteLayout,
    private: false,
  },
  {
    path: "/terms-conditions",
    element: <TermConditionsContainer/>,
    layout: SiteLayout,
    private: false,
  },
  {
    path: "/cancellation-policy",
    element: <CancellationPolicyContainer/>,
    layout: SiteLayout,
    private: false,
  },
  {
    path: "/company",
    element: <CompanyContainer/>,
    layout: SiteLayout,
    private: false,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword/>,
    layout: PlainLayout,
    private: false,
  },
  {
    path: "/address-book",
    element: <AddressContainer/>,
    layout: SiteLayout,
    private: true,
  },
  {
    path: "/add-Address",
    element: <AddAddressContainer/>,
    layout: SiteLayout,
    private: true,
  },
  {
    path: "/edit-address/:id",
    element: <EditAddressContainer/>,
    layout: SiteLayout,
    private: true,
  },
  {
    path: "/reset-password/:token",
    element: <ResetPasswordVerifyOTP/>,
    layout: PlainLayout,
    private: false,
  },
  {
    path: "/offer-listing/:itemId",
    element: <OfferListContainer/>,
    layout: SiteLayout,
    private: false,
  },
  {
    path: "/campaign-offer/:itemId",
    element: <CampaignOfferContainer/>,
    layout: SiteLayout,
    private: false,
  },
  {
    path: "/super-saver/:itemId",
    element: <SuperSaverContainer/>,
    layout: SiteLayout,
    private: false,
  },
  {
    path: "/contact-us",
    element: <ContactUsContainer/>,
    layout: SiteLayout,
    private: false,
  },
  {
    path: "",
    element: <PageNotFoundContainer/>,
    layout: SiteLayout,
    private: false,
  },
];



const RouteWithSubRoutes = (route, index) => (
  <Route
    key={index}
    path={route.path}
    element={<route.layout>{route.element}</route.layout>}
  />
);
const RouteWithPrivateRoutes = (route, index) => {
  // console.log('isAuthenticated:');
  // console.log(isAuthenticated());
  if (isAuthenticated() && !isGuest()) {
    
    return (
      <Route
        key={index}
        path={route.path}
        element={<route.layout>{route.element}</route.layout>}
      />
    );
  }
  return <Route key={index} path={route.path} element={<Navigate to="/" />} />;
};

export const RoutesPage = () => {
  const loader = (
    <div
      style={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <span className="spinner-border" />
    </div>
  );

  return (
    <Router>
        {/* <ErrorBoundary> */}
      <Suspense fallback={loader}>
        <Routes>
          {routeList.map((route, index) => (
            route.private
            ? RouteWithPrivateRoutes(route, index)
            :
            RouteWithSubRoutes(route, index)
          ))}
        </Routes>
      </Suspense>
      {/* </ErrorBoundary> */}
    </Router>
  );
};